import React from 'react';
import { ApplicationFormTemplate } from '../../../../../entities/applicant_tracking/ApplicationFormTemplate';
import { SurveySection } from '../../../../../entities/survey_engine/SurveySection';
import { ApplicationFormSection } from './ApplicationFormSection';
import { ApplicationFormApplyButton } from './ApplicationFormApplyButton';
import { ApplicationFormJobApplicationSection } from './ApplicationFormJobApplicationSection';
import { ApplicationFormCandidateConsent } from './ApplicationFormCandidateConsent';
import {
  Control,
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form';
import { Source } from '../../../../../entities/applicant_tracking/Source';
import { PreviewJobPost } from '../../../../../entities/applicant_tracking/PreviewJobPost';

interface PropTypes {
  applicationFormTemplate?: ApplicationFormTemplate;
  sources: Source[];
  previewMode: boolean;
  previewJobPost: PreviewJobPost;
  applicationFormTemplateConsent?: boolean;
  formRegister: UseFormRegister<any>;
  formControl?: Control<any, any>;
  formWatch: UseFormWatch<any>;
  formStateValid: boolean;
  getValues?: UseFormGetValues<any>;
  setValue?: UseFormSetValue<any>;
  formResetField: (controllerName: string) => void;
}

export function ApplicationFormTab(props: PropTypes) {
  if (props.applicationFormTemplate == null) return null;

  const consentEnabled: boolean =
    props.applicationFormTemplateConsent ??
    props.applicationFormTemplate.candidateConsentEnabled;

  return (
    <div className='mb-5'>
      {props.applicationFormTemplate.template.sections.map(
        (section: SurveySection) => (
          <ApplicationFormSection
            key={section.id}
            section={section}
            previewMode={props.previewMode}
            formRegister={props.formRegister}
            getValues={props.getValues}
            setValue={props.setValue}
            control={props.formControl}
          />
        ),
      )}

      <ApplicationFormJobApplicationSection
        previewJobPost={props.previewJobPost}
        sources={props.sources}
        applicationFormTemplate={props.applicationFormTemplate}
        previewMode={props.previewMode}
        formRegister={props.formRegister}
        formControl={props.formControl}
        formGetValues={props.getValues}
        formResetField={props.formResetField}
        formWatch={props.formWatch}
      />

      <ApplicationFormCandidateConsent
        candidateConsentEnabled={consentEnabled}
        previewMode={props.previewMode}
        formRegister={props.formRegister}
      />

      <ApplicationFormApplyButton
        previewMode={props.previewMode}
        disabled={!props.formStateValid}
      />
    </div>
  );
}
